<template>
  <section class="space-y-6 px-6 py-6">
    <div class="grid grid-cols-1 gap-6 md:grid-cols-2">
      <integration-card-component
        :icon="$icons.integrationPassword"
        title="Minha senha"
        description="Clique no botão abaixo para resetar sua senha na plataforma."
        actionText="Redefinir senha"
        :count="count_password"
        @action="resetPassword"
      />
      <integration-card-component
        :icon="$icons.integrationSignature"
        title="Assinatura eletrônica"
        description="Clique no botão abaixo para resetar e receber por e-mail sua nova assinatura."
        actionText="Gerar nova assinatura"
        :count="count_code"
        @action="resetSignature"
      />
    </div>

    <div class="bg-ontick-steel-100 dark:bg-ontick-graphite-500 inline-block min-w-full rounded-lg py-6 align-middle">
      <div class="px-6 pb-4">
        <h2 class="text-ontick-steel-900 text-lg font-semibold dark:text-gray-300 sm:text-2xl">
          Último login realizado
          <br class="sm:hidden" />em
          <span v-if="data.length">
            {{ moment(data[0].login_datetime).format("DD/MM/YYYY HH:mm:ss") }}
          </span>
        </h2>
        <p v-if="data.length" class="text-ontick-steel-900 hidden py-3 text-sm dark:text-gray-300 sm:block">
          {{ data[0].login_city }}/{{ data[0].login_ip }}/{{ data[0].login_user_agent }}
        </p>
        <p v-if="data.length" class="text-ontick-steel-900 py-3 text-sm dark:text-gray-300 sm:hidden">
          Local: {{ data[0].login_city }}
          <br />
          Navegador: {{ data[0].login_user_agent }}
        </p>
      </div>
      <div class="overflow-x-auto">
        <div class="border-ontick-steel-300 dark:border-ontick-steel-500 overflow-hidden border-t shadow">
          <table class="divide-ontick-steel-300 dark:divide-ontick-steel-500 min-w-full divide-y">
            <tbody
              class="divide-ontick-steel-300 dark:divide-ontick-steel-500 dark:bg-ontick-graphite-500 divide-y bg-gray-50 py-4"
            >
              <tr
                class="text-ontick-carbon-900 text-center dark:text-gray-400"
                v-for="(item, index) in data"
                :key="index"
              >
                <td class="p-4 text-sm">
                  {{ moment(item.login_datetime).format("DD/MM/YYYY HH:mm:ss") }}
                </td>
                <td class="p-4 text-sm sm:hidden">
                  <button class="text-ontick-blue-600 font-bold" @click="showInfo(item)">Informações</button>
                </td>
                <td class="hidden p-4 text-sm sm:table-cell">
                  {{ item.login_ip }}
                </td>
                <td class="hidden p-4 text-sm sm:table-cell">
                  {{ item.login_city }}
                </td>
                <td class="hidden p-4 text-sm sm:table-cell">
                  {{ item.login_user_agent }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <portal to="modal">
      <integration-modal-component @close="active_modal = false" :active="active_modal" />
    </portal>
  </section>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Timer from "@/app/shared/components/contador/timer.component";
import IntegrationModalComponent from "./integration.modal.component.vue";
import IntegrationCardComponent from "../../components/integration-card.component.vue";
import moment from "moment";
export default {
  name: "integration",
  components: {
    Timer,
    IntegrationModalComponent,
    IntegrationCardComponent,
  },

  data() {
    return {
      password_active: false,
      data: [],
      header: ["Data", "IP", "Cidade", "Dispositivo"],
      active_modal: false,
    };
  },

  created() {
    this.$api.get(this.$endpoint.LOGIN_HISTORY).then((res) => {
      this.data = res.data;
    });
  },

  computed: {
    ...mapState({
      count_password: (state) => state.accountTypes.count_password,
      count_code: (state) => state.accountTypes.count_code,
    }),
  },

  methods: {
    ...mapActions({
      updateCountPassword: "accountTypes/updateCountPassword",
      updateCountCode: "accountTypes/updateCountCode",
    }),
    showInfo(item) {
      this.$swal({
        title: "Informações",
        html: `<p class="text-left"><span class="font-bold text-gray-300">Data</span>: ${moment(
          item.login_datetime
        ).format("DD/MM/YYYY HH:mm:ss")}<br/><br/><span class="font-bold text-gray-300">Local</span>: ${
          item.login_city
        }<br/><br/><span class="font-bold text-gray-300">IP</span>: ${
          item.login_ip
        }<br/><br/><span class="font-bold text-gray-300">Navegador/Sistema</span>: ${item.login_user_agent}</p>`,
      });
    },
    resetPassword() {
      this.$api
        .post(this.$endpoint.RESET_PASSWORD)
        .then(() => {
          this.updateCountPassword(true);
          this.active_modal = true;

          setTimeout(() => this.updateCountPassword(false), 60000);
        })
        .catch((error) => {
          if (error.data.msg == "Já existe um reset code para este usuário (expiração: 5 minutos)") {
            this.active_modal = true;
          }

          this.$swal({
            title: error.data.msg,
            icon: "error",
            position: "center",
            showCloseButton: true,
            showCancelButton: true,
            showConfirmButton: false,
            cancelButtonText: "Fechar",
          });
        });
    },

    resetSignature() {
      this.$api
        .post(this.$endpoint.SIGNATURE_PASSWORD)
        .then((res) => {
          this.$swal({
            title: res.data.msg,
            icon: "success",
            icon: "success",
            iconHtml: this.$icons.swal_success,
            position: "center",
            timer: 5000,
            timerProgressBar: true,
          });

          this.updateCountCode(true);

          setTimeout(() => this.updateCountCode(false), 60000);
        })
        .catch((error) => {
          this.$swal({
            title: error.data.msg,
            icon: "error",
            position: "center",
            showCloseButton: true,
            showCancelButton: true,
            showConfirmButton: false,
            cancelButtonText: "Fechar",
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./integration.component.scss";

.fade-enter-active,
.fade-leave-active {
  transition: all 0.9s ease;
  overflow: hidden;
  visibility: visible;
  position: absolute;
  width: 100%;
  opacity: 1;
}

.fade-enter,
.fade-leave-to {
  visibility: hidden;
  width: 100%;
  opacity: 0;
}
</style>
